<template>
  <div class="s-pt-100 2xl:pb-[100px] bg-[#EBEBEB]">
    <div class="container mx-auto px-4 max-w-[1920px]">
      <div class="flex flex-row items-start justify-between gap-8">
        <!-- Logo & Description -->
        <div class="max-w-[260px]">
          <div class="flex items-end h-[40px]">
            <!-- Menggunakan items-end dan menyesuaikan height -->
            <router-link to="/" aria-label="casa sulivan">
              <img :src="logoDark" alt="" class="w-[190px]" />
              <!-- Mempertahankan ukuran original -->
            </router-link>
          </div>
          <p
            class="text-sm mt-3 leading-relaxed text-justify tracking-normal text-gray-700"
          >
            Casa Sulivan was formed in 2014 by Henry and Tania Sulivan. Henry has been
            working with his father's furniture manufacturing business for 25 years,
            whereas Tania has experience as a Regional Marketing Manager in a German-owned
            furniture and manufacturer, positioned in Australia & New Zealand.
          </p>
          <p class="mt-2 text-sm font-medium">
            © {{ year }} Casa Sulivan <i class="fa-solid fa-heart text-red-600"></i>
          </p>
        </div>

        <!-- Newsletter -->
        <div class="max-w-[250px]">
          <h5 class="text-xl font-medium">Let us reach you!</h5>
          <!-- Menghapus height fixed -->
          <div class="flex flex-col gap-4 mt-4">
            <input
              class="bg-white w-full h-12 p-4 outline-none"
              type="text"
              placeholder="Enter your email address"
            />
            <!-- <button class="btn btn-solid" data-text="Send Email">
              <span>Send Email</span>
            </button> -->
            <button
              class="btn btn-solid w-full xl:px-7 sm:w-fit px-6 lg:py-2 text-sm lg:text-base lg:px-7"
              data-text="Send Email"
            >
              <span>Send Email</span>
            </button>
          </div>
        </div>

        <!-- Our Service -->
        <div class="max-w-[200px]">
          <h4 class="text-xl font-medium">Our service</h4>
          <ul class="space-y-4 mt-4">
            <li v-for="(item, index) in footerLink2" :key="index">
              <a class="hover:text-primary leading-2" :to="item.link">{{ item.name }}</a>
            </li>
          </ul>
        </div>

        <!-- Contact Us -->
        <div class="max-w-[300px]">
          <h4 class="text-xl font-medium">Contact Us</h4>
          <ul class="space-y-4 mt-4">
            <li class="flex items-center gap-4">
              <img :src="maps" alt="" class="w-5 h-5" />
              <a href="https://maps.app.goo.gl/c72yz3quiGEtsUXk6">
                Jl. Pasar Lama No. 25 Plumbon – Cirebon, West Java – Indonesia
              </a>
            </li>
            <li class="flex items-center gap-4">
              <img :src="phone" alt="" class="w-5 h-5" />
              <a
                href="https://wa.link/afdqcm"
                class="font-extrabold italic animate-pulse"
              >
                Hi, I am Tania. WA me
              </a>
            </li>
            <li class="flex items-center gap-4">
              <img :src="email" alt="" class="w-5 h-5" />
              <a>mhsulivan@yahoo.com</a>
            </li>
          </ul>
        </div>

        <!-- Gallery -->
        <div class="max-w-[250px]">
          <h4 class="text-xl font-medium">Our gallery</h4>
          <div class="grid grid-cols-2 gap-2 mt-4">
            <img
              src="../../assets/img/acta/acta1.png"
              alt="Gallery 1"
              class="w-full h-20 object-cover rounded-md"
            />
            <img
              src="../../assets/img/black-pond/black-pond.png"
              alt="Gallery 2"
              class="w-full h-20 object-cover rounded-md"
            />
            <img
              src="../../assets/img/neonPigeon/NEON1.png"
              alt="Gallery 3"
              class="w-full h-20 object-cover rounded-md"
            />
            <img
              src="../../assets/img/phoenix/phoenix1.png"
              alt="Gallery 4"
              class="w-full h-20 object-cover rounded-md"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import logoDark from "@/assets/img/Casa-Sulivan-logo-new-brown.png";
// import logoLight from "@/assets/img/svg/logo-light.svg";
import maps from "@/assets/img/icon/maps-and-flags.svg";
import email from "@/assets/img/icon/post-office.svg";
import phone from "@/assets/img/icon/whatsappMono.svg";
import { footerLink2 } from "@/data/nav-data";

const year = ref(new Date().getFullYear());
</script>
